import _isEqual from 'lodash.isequal';

// eslint-disable-next-line import/prefer-default-export
export const isEqual = <T>(a: T, b: T, keys?: (keyof T)[]): boolean => {
  if (!keys) return _isEqual(a, b);
  return !keys.some(key => !_isEqual(a[key], b[key]));
};
